import { __rest } from "tslib";
import { h } from '@stencil/core';
import { isRoutingDisabled } from './utils';
import { passBreadcrumbsParams } from '../breadcrumbs/utils';
const RouterQdsLinkView = (props, children) => {
  const { name, url, storageName, breadcrumbs, pageName, pageId, size, importance, iconName, linkClassName, target, } = props;
  const storeBreadcrumbsParams = {
    id: pageId,
    name,
    url,
    storageName,
    breadcrumbs,
    pageName,
  };
  if (isRoutingDisabled(props)) {
    return (h("qds-standalone-link", { class: linkClassName, href: url, target: target !== null && target !== void 0 ? target : '_self', size: size, importance: importance, iconName: iconName, onClick: passBreadcrumbsParams(storeBreadcrumbsParams) }, children));
  }
  const _a = props, { routerClassName } = _a, routerProps = __rest(_a, ["routerClassName"]);
  return (h("pes-router-link", Object.assign({ key: pageId, class: routerClassName }, routerProps, { saveInIndexDB: passBreadcrumbsParams(storeBreadcrumbsParams) }), h("qds-standalone-link", { class: linkClassName, href: "#", size: size, importance: importance, iconName: iconName }, children)));
};
export default RouterQdsLinkView;
